module.exports = __webpack_public_path__ + "files/3f55a24a0acc144489eb58c7c75650da.png";